
import { Component, Prop, Vue } from 'bits/vue'

/**
 * @displayName OzLabelInput
 */

@Component({})
export default class OzLabelInput extends Vue {
  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Text which is appended to the end of the input slot
   * e.g. ".padlet.org"
   */
  @Prop({ required: false }) inputSuffix!: string

  /**
   * Describes the input field
   * e.g. "Minimum of 8 characters"
   */
  @Prop({ required: false }) inputDescriptor!: string

  /**
   * The input field points to `inputDescriptor` by using `:aria-describedby="${inputDescriptorId}"`.
   * Needs to be matched with `aria-describedby` value of the input field.
   *
   * @see https://web.dev/sign-in-form-best-practices/#accessible-password-inputs
   */
  @Prop({ required: false }) inputDescriptorId?: string
}
